import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserProfile } from '@lyceo/shared/auth/util-models';

export const AuthActions = createActionGroup({
  source: 'Auth API',
  events: {
    'Storage Token Valid': emptyProps(),
    'Storage Token Invalid': emptyProps(),
    'Update Authenticated': props<{ isAuthenticated: boolean }>(),
    'Load Discovery Document': emptyProps(),
    'Retry Load Discovery Document': emptyProps(),
    'Load Discovery Document Success': emptyProps(),
    'Load Discovery Document Failure': emptyProps(),
    'Refreshing Token Success': emptyProps(),
    'Refreshing Token Failure': emptyProps(),
    'Refreshing Token Not Needed': emptyProps(),
    'Login': props<{ kcIdpHint?: 'entree' }>(),
    'Try Login Success': emptyProps(),
    'Try Login Failure': emptyProps(),
    'Session error Logout': emptyProps(),
    'User Logout': emptyProps(),
    'Logout Success': emptyProps(),
    'Logout Failure': emptyProps(),
    'Mobile Logout Finish': emptyProps(),
    'Login Success': emptyProps(),
    'Mobile Try Login': props<{ urlSearch: string }>(),
    'Mobile Try Login Success': emptyProps(),
    'Mobile Try Login Failure': emptyProps(),
    'Load User Profile Success': props<{ profile: UserProfile }>(),
    'Load User Profile Failure': props<{ error: Error }>(),
  },
});
